export default __webpack_public_path__ + "static/media/rubik-v12-latin-regular.f11c4dcc.woff2";